<template>
  <form name="form" v-on:submit.prevent="submit" v-on:change="changeHandler">
    <div class="card-body parties">
      <div class="parties-list" v-if="view == 'parties'">
        <div v-if="party.type.name !== 'client'">
          <div
            class="col-md-3 parties-list-card"
            v-bind:key="index"
            v-for="(party, index) in parties"
          >
            <div
              class="parties-list-card-inner"
              v-on:click.prevent="editParty(party)"
            >
              <i v-if="party.type.name === 'occupant'" class="material-icons"
                >directions_car</i
              >
              <i v-if="party.type.name === 'witness'" class="material-icons"
                >visibility</i
              >
              <i v-if="party.type.name === 'third_party'" class="material-icons"
                >person_outline</i
              >
              <h4>
                {{ party.type.label }}
              </h4>
              <ul class="party-details">
                <li v-if="party.party.last_name">
                  {{ party.party.first_name + ' ' + party.party.last_name }}
                </li>
                <li v-if="party.party.address_line_one">
                  {{ party.party.address_line_one }}
                </li>
                <li v-if="party.party.address_line_two">
                  {{ party.party.address_line_two }}
                </li>
                <li v-if="party.party.city">{{ party.party.city }}</li>
                <li v-if="party.party.telephone">
                  {{ party.party.telephone }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-3 parties-list-card parties-list-add">
          <div
            class="parties-list-card-inner"
            v-on:click.prevent="setView('party-types')"
          >
            <h4>Add Party</h4>
            <i class="material-icons">add_circle_outline</i>
          </div>
        </div>
      </div>

      <div class="party-types" v-if="view == 'party-types'">
        <div class="col-12 navigation">
          <a v-on:click.prevent="setView('parties')">Back To Parties</a>
        </div>
        <div class="col-md-4 create-party-card create-party-add">
          <div
            class="parties-list-card-inner"
            v-on:click.prevent="loadThirdParty()"
          >
            <h4>Add Third Party</h4>
            <i class="material-icons">add_circle_outline</i>
          </div>
        </div>
        <div class="col-md-4 create-party-card create-party-add">
          <div
            class="parties-list-card-inner"
            v-on:click.prevent="loadOccupant()"
          >
            <h4>Add Occupant</h4>
            <i class="material-icons">add_circle_outline</i>
          </div>
        </div>
        <div class="col-md-4 create-party-card create-party-add">
          <div
            class="parties-list-card-inner"
            v-on:click.prevent="loadWitness()"
          >
            <h4>Add Witness</h4>
            <i class="material-icons">add_circle_outline</i>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      parties: [],
      view: 'parties'
    };
  },

  mounted() {
    this.mount();
  },

  computed: {},

  methods: {
    mount() {
      window.Ajax.get('/incidents/' + this.incident + '/parties')
        .then(response => {
          this.parties = response.data;
        })
        .catch(response => {});
    },

    changeHandler() {
      if (!this.data_entered) {
        this.data_entered = true;
      }
      this.$emit('unsaved-data', this.data_entered);
    },

    setView(view) {
      this.view = view;
    },

    loadOccupant() {
      this.$router.push(
        `/first-notice-of-loss-plus/${this.incident}/parties/occupant`
      );
    },

    loadWitness() {
      this.$router.push(
        `/first-notice-of-loss-plus/${this.incident}/parties/witness`
      );
    },

    loadThirdParty() {
      this.$router.push(
        `/first-notice-of-loss-plus/${this.incident}/parties/third-party`
      );
    },

    editParty(party) {
      let partyType = party.type.name;
      let partyId = party.party.identifier;
      let url;

      partyType === 'occupant'
        ? (url = `/first-notice-of-loss-plus/${this.incident}/parties/occupant/${partyId}`)
        : partyType === 'witness'
        ? (url = `/first-notice-of-loss-plus/${this.incident}/parties/witness/${partyId}`)
        : (url = `/first-notice-of-loss-plus/${this.incident}/parties/third-party/${partyId}`);

      this.$router.push(url);
    }
  },

  watch: {
    $route(to, from) {
      this.mount();
    }
  }
};
</script>
